'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        children = props.children,
        theme = props.theme,
        className = props.className,
        dataTn = props.dataTn,
        isDangerousAction = props.isDangerousAction,
        href = props.href,
        btnProps = (0, _objectWithoutProperties3.default)(props, ['size', 'children', 'theme', 'className', 'dataTn', 'isDangerousAction', 'href']);


    if (theme) {
        var outputClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, theme.isDangerousAction, isDangerousAction), theme.button, theme[size], className);
        if (href) {
            return _react2.default.createElement(
                'a',
                (0, _extends3.default)({}, btnProps, {
                    className: outputClassName,
                    'data-tn': dataTn,
                    href: href
                }),
                children
            );
        }
        return _react2.default.createElement(
            'button',
            (0, _extends3.default)({}, btnProps, {
                className: outputClassName,
                'data-tn': dataTn
            }),
            children
        );
    }
    return null;
};

Button.displayName = 'Button';

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Button/index.js
// module id = ./node_modules/dibs-elements/lib/Button/index.js
// module chunks = 4